var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrightnessAlert = function SvgBrightnessAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.73q.343 0 .575-.231a.78.78 0 0 0 .233-.576.78.78 0 0 0-.232-.575.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.575q0 .343.232.576a.78.78 0 0 0 .576.232m-.75-3.653h1.5v-6h-1.5zm.75 9.53L8.86 19.5H4.5v-4.36L1.392 12 4.5 8.86V4.5h4.36L12 1.392 15.14 4.5h4.36v4.36L22.608 12 19.5 15.14v4.36h-4.36zm0-2.107 2.5-2.5H18v-3.5l2.5-2.5L18 9.5V6h-3.5L12 3.5 9.5 6H6v3.5L3.5 12 6 14.5V18h3.5z"
  })));
};
export default SvgBrightnessAlert;